/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_c4f61212"]'><div :class='["dialog-btn-demo"]'><cube-button @_click="onClickDialog">Dialog - confirm-with-inner-icon</cube-button><cube-dialog ref="__mpx_ref_dialogConfirmWithInnerIcon__" icon="alert" type="confirm" cancel-btn="取消" confirm-btn="确认"><div slot="title">测试标题</div><div slot="content" :class='["dialog-btn-content"]'>测试content</div></cube-dialog></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_c4f61212"}'>
.dialog-btn-content
  text-align center
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_c4f61212"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_c4f61212"}
  /** script content **/
  require("./dialog-confirm-with-inner-icon.mpx.js?isComponent&outputPath=components%2Fdialog-confirm-with-inner-iconc4f61212%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-confirm-with-inner-icon.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-confirm-with-inner-iconc4f61212%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_c4f61212"],
    ctorType: "component",
    outputPath: "components/dialog-confirm-with-inner-iconc4f61212/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>